import React from "react";
import { CreateOrder, ApproveOrder, CreateInstituteOrder } from "../CourseEnrollment/Payment/Components/PaypalPayment/Helpers/CreateOrder";

export const PaypalCheckoutBtn = ({
    PayPalButton,
    currency,
    dispatch,
    Package,
    setInstituteData,
    discount,
    InstituteData,
    handleSubmit
}) => {
    console.log("Package in PaypalCheckoutBtn is:",Package)
    console.log("discount in PaypalCheckoutBtn is:",discount)

    // Remove $ and convert Package to number
    // const originalPrice = parseFloat((Package?.replace('$', '').trim()) ?? '0');
    
    // Check and apply discount if available
    // const finalPrice = discount
    // ? (originalPrice - discount)
    // : originalPrice.toFixed(2);

    // console.log("Final Price after discount:", finalPrice);

    return (
        <div
            style={{ width: "100%", minHeight: "200px" }}
        >           
            <PayPalButton
                createOrder={(data, actions) =>
                    CreateInstituteOrder(`$${Package}`)
                }

                onApprove={async (data, actions) => {
                    try {

                    // Construct updated payment info
                    const updatedPaymentInfo = {
                        ...InstituteData.paymentInfo,
                        paymentSuccessful: true,
                        paypalOrderId: data.orderID,
                    };

                    // ✅ Call handleSubmit and pass the updated data
                    handleSubmit(updatedPaymentInfo);
                    // Show an alert or toast
                    //alert(`Payment Successful for ${Package || "your selected package"}`);
                    } catch (error) {
                    console.error("Error capturing payment:", error);
                    alert("Payment failed. Please try again.");
                    }
                }}

                // onApprove={async (data, actions) => {
                //     try {

                //     // Set payment successful and optionally reset other fields if needed
                //     setInstituteData((prevData) => ({
                //         ...prevData,
                //         paymentInfo: {
                //         ...prevData.paymentInfo,
                //         paymentSuccessful: true,
                //         paypalOrderId: data.orderID,
                //         },
                //     }));

                //     // Show an alert or toast
                //     alert(`Payment Successful for ${Package || "your selected package"}`);
                //     } catch (error) {
                //     console.error("Error capturing payment:", error);
                //     alert("Payment failed. Please try again.");
                //     }
                // }}
                
            />
        </div>
    );
};















// import React from "react";
// import { CreateOrder, ApproveOrder, CreateInstituteOrder } from "../CourseEnrollment/Payment/Components/PaypalPayment/Helpers/CreateOrder";
// import { CheckoutPaymentFailureA, CheckoutPaymentSuccessA } from "../../Actions/UserA";
// import axios from "axios";

// export const PaypalCheckoutBtn = ({
//     PayPalButton,
//     currency,
//     dispatch,
//     Package,
//     setInstituteData,
//     discount,
//     InstituteData,
//     handleSubmit,
//     instituteId,
//     setOpenSignupScreen
// }) => {
//     console.log("Package in PaypalCheckoutBtn is:",Package)
//     console.log("discount in PaypalCheckoutBtn is:",discount)

//     // Remove $ and convert Package to number
//     // const originalPrice = parseFloat((Package?.replace('$', '').trim()) ?? '0');
    
//     // Check and apply discount if available
//     // const finalPrice = discount
//     // ? (originalPrice - discount)
//     // : originalPrice.toFixed(2);

//     // console.log("Final Price after discount:", finalPrice);

//     return (
//         <div style={{ width: "100%", minHeight: "200px" }}>  

//         <PayPalButton
//         createOrder={async (data, actions) => {
//             try {
//             // ✅ Step 1: Create PayPal order first
//             const orderId = await CreateInstituteOrder(`$${Package}`); // Don't pass `$`
//             console.log("PayPal Order ID:", orderId);

//             if (!orderId) {
//                 console.log("No order ID received from backend");
//                 }

//             // ✅ Step 2: Update your backend form/db after creating PayPal order
//             const updatedPaymentInfo = {
//                 ...InstituteData.paymentInfo,
//                 grandTotal: Package,
//             };
//             await handleSubmit(updatedPaymentInfo);

//             // ✅ Step 3: Return PayPal order ID to SDK
//             return orderId;
//             } catch (error) {
//             console.error("Error during order creation or form submission:", error);
//             alert("Something went wrong before payment. Please try again.");
//             throw error; // PayPal will stop the flow if this fails
//             }
//         }}

//         onApprove={async (data, actions) => {
//             try {
//             const payPalDetails = {
//                 paypalOrderId: data.orderID, // Use `orderID`, not `id`
//                 paymentType: "paypal",
//             };

//             dispatch(
//                 CheckoutPaymentSuccessA(
//                 payPalDetails,
//                 instituteId,
//                 () => {
//                     console.log("Institute Registered Successfully!");
//                     setOpenSignupScreen("SubmissionScreen");
//                 },
//                 (errorMessage) => {
//                     console.log(errorMessage);
//                 }
//                 )
//             );
//             } catch (error) {
//             console.error("Error capturing payment:", error);

//             const errorMessage =
//                 error?.response?.data?.error ||
//                 (typeof error === "object" ? error.message : "Order creation failed");

//             dispatch(CheckoutPaymentFailureA({ [errorMessage]: "" }, instituteId));
//             alert("Payment failed. Please try again.");
//             }
//         }}
//         />


         
//             {/* <PayPalButton
//              // Run this BEFORE PayPal popup opens
//              onClick={async (data, actions) => {
//                     try {
//                     const updatedPaymentInfo = {
//                         ...InstituteData.paymentInfo,
//                         grandTotal: Package,
//                     };

//                     await handleSubmit(updatedPaymentInfo); // ✅ Upload files, update DB, etc.
//                     return actions.resolve(); // ✅ Allow PayPal popup to continue
//                     } catch (error) {
//                     console.error("Form submission failed before payment:", error);
//                     alert("Something went wrong. Please check your form and try again.");
//                     return actions.reject(); // ❌ Cancel PayPal popup
//                     }
//                 }}

//                 createOrder={(data, actions) =>
//                     CreateInstituteOrder(`$${Package}`)
//                 }

//                 onApprove={async (data, actions) => {
//                     try {

//                         const payPalDetails = {
//                         paypalOrderId: data.id,
//                         paymentType:"paypal"
//                     };
//                     // Dispatch CheckoutPaymentSuccess
//                     dispatch(CheckoutPaymentSuccessA(payPalDetails, instituteId,
//                         () => {
//                             console.log("Institute Registered Successfully!");
//                             setOpenSignupScreen("SubmissionScreen");
//                         },
//                         (errorMessage) => {
//                             console.log(errorMessage); // show error
//                         }
//                     )); // or pass what’s needed

//                     } catch (error) {
//                     console.error("Error capturing payment:", error);
//                     // 4. Dispatch CheckoutPaymentFailure
//                     const errorMessage =
//                         error?.response?.data?.error ||
//                         (typeof error === "object" ? error.message : "Order creation failed");
                    
//                     dispatch(CheckoutPaymentFailureA({ [errorMessage]: "" }, instituteId));
//                     alert("Payment failed. Please try again.");
//                     }
//                 }}
//             /> */}
//         </div>
//     );
// };


// createOrder={async (data, actions) => {
    //     const orderId = await CreateInstituteOrder(`$${Package}`, InstituteData, handleSubmit);
    //     return orderId;
    // }}

// createOrder={async (data, actions) => {
//     // 1. Call handleSubmit first (wait for it if it's async)
//     const updatedPaymentInfo = {
//         ...InstituteData.paymentInfo,
//         grandTotal: Package
//     };

//     await handleSubmit(updatedPaymentInfo); // or pass any data if needed

//     // 2. Call your order creation API
//     const { datapaypal } = await axios.post("/api/instituteorders", {
//         TotalPrice: `$${Package}`,
//         Currency: "USD",
//     });

//     console.log("createorder", datapaypal);

//     return datapaypal.id; // return order ID to PayPal
// }}

// onApprove={async (data, actions) => {
//     try {

//     // Set payment successful and optionally reset other fields if needed
//     setInstituteData((prevData) => ({
//         ...prevData,
//         paymentInfo: {
//         ...prevData.paymentInfo,
//         paymentSuccessful: true,
//         paypalOrderId: data.orderID,
//         },
//     }));

//     // Show an alert or toast
//     alert(`Payment Successful for ${Package || "your selected package"}`);
//     } catch (error) {
//     console.error("Error capturing payment:", error);
//     alert("Payment failed. Please try again.");
//     }
// }}

